import { defineMessages } from 'react-intl';

const upgradeRatingsMessages = defineMessages({
  featureName: {
    id: 'unlock.ratings.unauthorized.role',
    defaultMessage: 'Visit Feedback',
  },
  featureHeading: {
    id: 'unlock.ratings.unauthorized.role.heading',
    defaultMessage: 'Unlock Visit Feedback',
  },
  featureSummary: {
    id: 'unlock.ratings.unauthorized.role.summary',
    defaultMessage: 'See what high schools think about your past visits',
  },
  featureUnlockDetails: {
    id: 'unlock.ratings.unauthorized.role.details',
    // eslint-disable-next-line max-len
    defaultMessage: 'Visit Feedback is only available to users with the Administrator role.',
  },
});

export default upgradeRatingsMessages;
